import { render } from "./NavigationBasicItem.vue?vue&type=template&id=756ad597"
import script from "./NavigationBasicItem.vue?vue&type=script&lang=js"
export * from "./NavigationBasicItem.vue?vue&type=script&lang=js"
script.render = render

export default script